import 'angular';
import '../controllers/RecentTasksComponentController';
import './assigned_tasks.html';

angular.module('GorillaBoy.Dboard')
.directive('assignedTasks', [() => {
    return {
        scope: true,
        controller: 'RecentTasksComponentController',
        //The following URL is relative to the index.html (DocumentRoot) and is used at runtime
        templateUrl: './dboard/components/assigned_tasks.html'
    };
}]);
